import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import _ from "lodash"
import Dropdown from "react-bootstrap/Dropdown"

import * as ACTIONS from "../../../../store/actions"
import * as clearview from "../../../../components/@Clearview"

import { Avatar } from "../../../../components"
import { DropdownDivider } from "react-bootstrap"

class PeriodEndAssignedTo extends React.Component {
	static propTypes = {
		periodEnd: PropTypes.object.isRequired,
		user: PropTypes.object.isRequired,
	}

	constructor(props) {
		super(props)
		this.props = props

		this.setAssignedTo = this.setAssignedTo.bind(this)
		this.unsetAssignedTo = this.unsetAssignedTo.bind(this)
	}

	setAssignedTo(assignedToUser) {
		if (this.props.periodEnd.inHouseAssignedToId !== assignedToUser.id) {
			this.props.periodEnd.inHouseAssignedTo = assignedToUser
			this.props.periodEnd.inHouseAssignedToId = assignedToUser.id
			this.props.doFieldUpdate(this.props.periodEnd, "inHouseAssignedToId")
		}
	}

	unsetAssignedTo() {
		if (this.props.periodEnd.inHouseAssignedToId) {
			this.props.periodEnd.inHouseAssignedTo = undefined
			this.props.periodEnd.inHouseAssignedToId = undefined
			this.props.doFieldUpdate(this.props.periodEnd, "inHouseAssignedToId")
		}
	}

	render() {
		const { periodEnd, user } = this.props

		// const inHouseUsers = (
		// 	ACTIONS.findTeam(
		// 		periodEnd.property,
		// 		c => c.type === "Customer",
		// 		t => t.type === "Users"
		// 	)?.users ?? []
		// ).sort((a, b) => clearview.caseInsensitiveSort(a.initials, b.initials))

		const actors = user.isInHouse ? ACTIONS.actorsForBusiness(periodEnd.property) : { inHouse: [], inHouseAdmins: [] }

		const inHouseActors = _.unionBy(actors.inHouseAdmin, actors.inHouse, it => it.id).sort((a, b) => clearview.caseInsensitiveSort(a.initials, b.initials))
		const thisInHouseUser = inHouseActors.find(it => it.id === user.id)

		return (
			!!thisInHouseUser && (
				<Dropdown
					className="align-self-center ml-auto"
					direction="left"
					style={{ display: "inline-block" }}
					onToggle={(_, meta) => clearview.StopPropagation(meta.originalEvent)}
				>
					<Dropdown.Toggle
						disabled={thisInHouseUser.role === "Reader"}
						as={clearview.DropdownToggleNoArrow}
						color="link"
						variant="none"
						style={{ padding: 2 }}
					>
						<Avatar.Font
							user={periodEnd.inHouseAssignedTo}
							size="sm"
							className="avatar-with-text"
							title={clearview.ifSomething(periodEnd.inHouseAssignedTo, `Assigned to ${periodEnd.inHouseAssignedTo?.name}`, "Unassigned")}
						></Avatar.Font>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item className="text-secondary" onClick={this.unsetAssignedTo}>
							<Avatar.Font user={undefined} size="sm" className="avatar-with-text-middle mr-1"></Avatar.Font> Unassigned
						</Dropdown.Item>
						<Dropdown.Item className="text-primary" onClick={e => this.setAssignedTo(user)}>
							<Avatar.Font user={user} size="sm" className="avatar-with-text-middle mr-1"></Avatar.Font> Self ({user.name})
						</Dropdown.Item>
						<DropdownDivider />
						{inHouseActors
							.filter(it => it.id !== user.id)
							.map(inHouseUser => (
								<Dropdown.Item key={inHouseUser.id} className="text-primary" onClick={e => this.setAssignedTo(inHouseUser)}>
									<Avatar.Font user={inHouseUser} size="sm" className="avatar-with-text-middle mr-1"></Avatar.Font> {inHouseUser.name}
								</Dropdown.Item>
							))}
					</Dropdown.Menu>
				</Dropdown>
			)
		)
	}
}

const mapStateToProps = state => {
	const { userReducer } = state
	return {
		user: userReducer.user || clearview.User.UnauthenticatedUser,
	}
}

const mapDispatchToProps = dispatch => ({
	doFieldUpdate: (periodEnd, fieldName) =>
		dispatch({
			type: ACTIONS.PERIODEND_FIELD_UPDATE,
			fieldName: fieldName,
			periodEnd: periodEnd,
		}),
})

PeriodEndAssignedTo = connect(mapStateToProps, mapDispatchToProps)(PeriodEndAssignedTo)

export { PeriodEndAssignedTo }
